import { Controller } from "@hotwired/stimulus";

// Choix du signataire d'un document : n'affiche (et n'envoie) que les
// formules du signataire choisi, et tient à jour le champ « inclure la
// signature ».
export default class extends Controller {
  static targets = ["select", "formulas", "include"];

  choose() {
    const chosen = this.selectTarget.value;

    this.formulasTargets.forEach((fieldset) => {
      const active = fieldset.dataset.signatoryId === chosen;
      fieldset.disabled = !active;
      fieldset.style.display = active ? "block" : "none";
      if (active && !fieldset.querySelector("input[type=radio]:checked")) {
        const first = fieldset.querySelector("input[type=radio]");
        if (first) first.checked = true;
      }
    });

    if (this.hasIncludeTarget) this.includeTarget.value = chosen ? "1" : "0";
  }
}
